import React from "react"
import { Box, Grid, IconButton, Typography } from "@mui/material"
import ColorBox from "./ColorBox"
import { getCurrencyStringFromNumber } from "../../Util/Util"

const CustomOrderColorOption = ({
  title,
  helpText,
  parentColorOption,
  setChildColorOption,
  childColorOptions,
  childColorOption,
  colorOption,
  setColorOption,
  colorOptions,
  showColorPicker,
  showColorOptions,
  updateOptions,
  orderData,
  isStaff,
}) => {
  const disabled = orderData?.locked && !isStaff
  const setColorOptionWrapper = (cO) => {
    let newOptions = []
    if (colorOption?.type === "bottom_color") {
      if (childColorOption?.value !== "#ffffff") {
        let newChildOption = childColorOptions.find((x) => x.value === cO.value)
        setChildColorOption(newChildOption)
        newOptions.push(newChildOption)
      }
    }
    newOptions.push(cO)
    setColorOption(cO)
    updateOptions(newOptions)
  }

  if (colorOption?.type === "deck_color" && !parentColorOption) {
    helpText += ". First select the bottom color"
  }

  if (colorOption?.price > 0) {
    title += ` ${getCurrencyStringFromNumber(colorOption.price)}`
  }

  if (!colorOption && !colorOptions?.length) {
    return <React.Fragment />
  }

  const showGrid = true
  const hexToHsl = (hex) => {
    const r = parseInt(hex.slice(1,3),16)/255, g = parseInt(hex.slice(3,5),16)/255, b = parseInt(hex.slice(5,7),16)/255
    const max = Math.max(r,g,b), min = Math.min(r,g,b), l = (max+min)/2
    if (max === min) return [0, 0, l]
    const d = max - min, s = l > 0.5 ? d/(2-max-min) : d/(max+min)
    let h = max === r ? ((g-b)/d + (g<b?6:0))/6 : max === g ? ((b-r)/d+2)/6 : ((r-g)/d+4)/6
    return [h, s, l]
  }
  const sortByTone = (opts) => [...opts].sort((a, b) => {
    const [ha, sa, la] = hexToHsl(a.value || "#000")
    const [hb, sb, lb] = hexToHsl(b.value || "#000")
    if (sa < 0.1 && sb < 0.1) return lb - la // neutrals by lightness
    if (sa < 0.1) return 1 // neutrals last
    if (sb < 0.1) return -1
    return ha - hb || lb - la
  })

  const isBottomColor = colorOption?.type === "bottom_color" || title === "Bottom Color"
  const gridOptions = Array.isArray(colorOptions) ? sortByTone(colorOptions) : []

  return (
    <Box my={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="body1"
          style={{ fontFamily: "Josefin Sans", fontWeight: "bold" }}
        >
          {title}
        </Typography>
      </Box>
      {showGrid && gridOptions.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 0.8, mt: 1 }}>
          {isBottomColor && (
            <Box
              onClick={() => {
                if (disabled) return
                const whiteChild = childColorOptions?.find((x) => x.value === "#ffffff")
                if (whiteChild) { setChildColorOption(whiteChild) }
                setColorOption(null)
                updateOptions([], colorOption ? [colorOption] : [])
              }}
              title="No Color"
              sx={{
                width: 48, height: 48, borderRadius: 1.5, cursor: disabled ? "default" : "pointer",
                bgcolor: "#ffffff", border: !colorOption ? "3px solid #c8b99a" : "1px solid rgba(255,255,255,0.2)",
                boxShadow: !colorOption ? "0 0 8px rgba(200,185,154,0.5)" : "none",
                position: "relative", overflow: "hidden",
                m: 0.5, transition: "all 0.15s",
                "&:hover": { border: "2px solid rgba(255,255,255,0.4)", transform: "scale(1.08)" },
              }}
            >
              <Box sx={{ position: "absolute", top: 0, left: "50%", width: 2, height: "140%", bgcolor: "#cc0000", transform: "translateX(-50%) rotate(45deg)", transformOrigin: "top center" }} />
            </Box>
          )}
          {gridOptions.map((cO) => (
            <ColorBox
              key={cO.id || cO.value}
              colorOption={cO}
              clickable={!disabled}
              selected={colorOption?.value === cO?.value}
              handleColorSelect={setColorOptionWrapper}
            />
          ))}
        </Box>
      )}
      {helpText && (
        <Box mt={0.5}>
          <Typography variant="caption" style={{ fontFamily: "Josefin Sans" }}>
            {helpText}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default CustomOrderColorOption
